export const tagModuleCodes = {
	apiEntityTypeValidationMessage: 49,
	tagType: 1094,
	tagAdded: 1108,
	searchTip: 1854,
	tagAlreadyExists: 2014,
	singular: 2398,
	plural: 2399,
	popularSkills: 4500,
	selectSkillPlaceholder: 4501,
	createNewTagValidationMessage: 4503,
	mergeTag: 4504,
	merge: 4505,
	mergeTagWizardStep1Title1: 4506,
	mergeTagWizardStep1Title2: 4507,
	mergeTagWizardStep2Title1: 4508,
	mergeTagWizardValidationMessage1: 4509,
	mergeTagWizardValidationMessage2: 4510,
	mergeTagWizardSuccessTip: 4511,
	mergeTagWizardGeneralTagTypeCategory: 4512,
	mergeTagWizardSkillTagTypeCategory: 4513,
	mergeTagWizardValidationMessage3: 4514,
	delete: 4516,
	deleteTagMessage: 4517,
	deleteTagSuccessTip: 4518,
	deleteTagModalWindowTitle: 4519,
	employerContactPersons: 4520,
	selectOrCreateNewTag: 5326,
	keyIndicatorCountDescription: 5330,
	popularTags: 5331,
	total: 5332,
	entityType: 5333,
	selectEntityType: 5334,
	selectTag: 5349,
	addTag: 5517,
	editTag: 5518,
	tagAddWizardSuccessTip: 5519,
	tagEditWizardSuccessTip: 5520,
};
